import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import App from "./App";
import { env } from "./utils/env";

import dataDogRUMWorker from "./utils/dataDogRUMWorker";

import "../public/fonts/inter/inter.css";
import "../public/fonts/index.css";
import "react-toastify/dist/ReactToastify.css";
import KAESAuth from "./components/Auth";

async function initializeApp() {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  const CLIENT_SIDE_ID = import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID;

  const LaunchDarklyProvider = await asyncWithLDProvider({
    clientSideID: CLIENT_SIDE_ID,
    timeout: 2.5,
  });

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <LaunchDarklyProvider>
          <KAESAuth
            client_id={env.cognitoClientId}
            authority={env.cognitoBaseUrl}
            redirect_uri={`${env.applicationBaseUrl}/login`}
            silent_redirect_uri="/"
            metadata={{
              authorization_endpoint: `${env.cognitoBaseUrl}/login`,
              token_endpoint: `${env.cognitoBaseUrl}/oauth2/token`,
              revocation_endpoint: `${env.cognitoBaseUrl}/oauth2/revoke`,
              userinfo_endpoint: `${env.cognitoBaseUrl}/oauth2/userInfo`,
            }}
            storagePrefix="nitro"
            loadingStyle={{
              color: "rgb(20, 141, 211)",
              backgroundColor: "white",
            }}
          >
            <App />
          </KAESAuth>
        </LaunchDarklyProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

initializeApp();

dataDogRUMWorker();
